import React, { useState } from "react";
import BlogSearchInput from "@/components/views/blog/details/search-input/index";

export default function SearchBlogInput() {
  const [districtQuery, setDistrictQuery] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState({} as any);

  const onChange = (value: string) => {
    setDistrictQuery(value);
  };

  return (
    <div>
      <BlogSearchInput
        index={0}
        className="!max-w-full !min-w-full !w-full"
        query={districtQuery}
        onChangeQuery={(value) => onChange(value)}
        selectedData={selectedDistrict}
        setSelectedData={setSelectedDistrict}
      />
    </div>
  );
}
